"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsDataGrid = void 0;
var _xDataGrid = require("@mui/x-data-grid");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const _excluded = ["columns", "rows", "initialState", "pageSizeOptions", "getRowId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Data grid component using MUI X DataGrid.
 * 
 * Demos:
 * - [DataGrid](https://mui.com/x/react-data-grid/demo/)
 * 
 * API:
 * - [DataGrid API](https://mui.com/x/api/data-grid/data-grid/)
 * 
 * @param {object} props - Component props.
 * @param {Array} props.columns - Columns configuration for the data grid.
 * @param {Array} props.rows - Rows of data to display in the grid.
 * @param {object} [props.initialState={}] - Initial state configuration for the data grid.
 * @param {Array} [props.pageSizeOptions=[10, 25, 50, 100]] - Options for page size in pagination.
 * @param {function} [props.getRowId=(row) => row.pk] - Function to get the unique ID for each row.
 * @returns {JSX.Element} DataGrid component.
 */
const DmsDataGrid = _ref => {
  var _initialState$columns, _initialState$paginat, _initialState$sorting, _defaultInitialState$;
  let {
      columns,
      rows,
      initialState = {},
      pageSizeOptions = [10, 25, 50, 100],
      getRowId = row => row.pk
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const completeColumns = [...columns, {
    field: 'pk',
    headerName: 'PK',
    control: 'hidden',
    hidden: true
  }];

  // Default initial state configuration
  const defaultInitialState = {
    pagination: {
      paginationModel: {
        pageSize: 10,
        page: 0
      }
    },
    sorting: {
      sortModel: [{
        field: 'pk',
        sort: 'asc'
      }]
    }
  };
  const columnVisibilityModel = completeColumns.reduce((model, col) => {
    model[col.field] = !col.hidden;
    return model;
  }, {});

  // Merge default and provided initial states
  const mergedInitialState = _objectSpread(_objectSpread(_objectSpread({}, defaultInitialState), initialState), {}, {
    columns: _objectSpread(_objectSpread({}, initialState.columns), {}, {
      columnVisibilityModel: _objectSpread(_objectSpread({}, columnVisibilityModel), (_initialState$columns = initialState.columns) === null || _initialState$columns === void 0 ? void 0 : _initialState$columns.columnVisibilityModel)
    }),
    pagination: _objectSpread(_objectSpread(_objectSpread({}, defaultInitialState.pagination), initialState.pagination), {}, {
      paginationModel: _objectSpread(_objectSpread({}, defaultInitialState.pagination.paginationModel), (_initialState$paginat = initialState.pagination) === null || _initialState$paginat === void 0 ? void 0 : _initialState$paginat.paginationModel)
    }),
    sorting: _objectSpread(_objectSpread(_objectSpread({}, defaultInitialState.sorting), initialState.sorting), {}, {
      sortModel: ((_initialState$sorting = initialState.sorting) === null || _initialState$sorting === void 0 ? void 0 : _initialState$sorting.sortModel) || ((_defaultInitialState$ = defaultInitialState.sorting) === null || _defaultInitialState$ === void 0 ? void 0 : _defaultInitialState$.sortModel)
    })
  });
  return /*#__PURE__*/_react.default.createElement(_xDataGrid.DataGrid, _extends({
    initialState: mergedInitialState,
    rows: rows,
    columns: completeColumns,
    getRowId: getRowId,
    pageSizeOptions: pageSizeOptions,
    autoHeight: true
  }, props));
};
exports.DmsDataGrid = DmsDataGrid;
DmsDataGrid.propTypes = {
  columns: _propTypes.default.array.isRequired,
  rows: _propTypes.default.array.isRequired,
  initialState: _propTypes.default.object,
  pageSizeOptions: _propTypes.default.array,
  getRowId: _propTypes.default.func
};